import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  createFilterOptions,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from "@mui/material";
import { BaseKey } from "@refinedev/core";
import { ListProps, useAutocomplete } from "@refinedev/mui";
import { config } from "config";
import React, { useState } from "react";
import { dataProvider } from "rest-data-provider";
import UserRole from "@warriortrading/warriortrading.hermes.common.feathers/enums/userRole";
interface ICategory {
  id: number;
  name: string;
}
type ExtendedListProps = ListProps & {
  userId: BaseKey | undefined;
  dataUpdate: (e: any) => void;
};
export const RoomMembersList: React.FC<ExtendedListProps> = ({
  title,
  canCreate,
  children,
  createButtonProps,
  resource: resourceFromProps,
  wrapperProps,
  headerProps,
  contentProps,
  userId,
  headerButtonProps,
  dataUpdate,
  headerButtons,
}) => {
  const apiUrl = config().server.api;
  const { autocompleteProps } = useAutocomplete<ICategory>({
    resource: "rooms",
    pagination: {
      pageSize: config().relationPageSize,
    },
    sorters: [
      {
        field: "name",
        order: "asc",
      },
    ],
  });
  const [open, setOpen] = useState(false);
  const [userRoleState, setUserRoleState] = useState(3);
  const [roomId, setRoomId] = useState("");
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleSave = () => {
    dataProvider(apiUrl)
      .create({
        resource: "room-member",
        variables: {
          role: userRoleState,
          status: 0,
          admin: "true",
          userId,
          roomId,
        },
      })
      .then(() => {
        dataUpdate(true);
      })
      .catch((err) => {
        alert("ERROR: Please check if an existing room has been added?");
      });
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const filterOptions = createFilterOptions({
    stringify: (option: any) => option.name,
  });
  return (
    <Card {...(wrapperProps ?? {})}>
      <CardHeader
        sx={{ display: "flex", flexWrap: "wrap" }}
        color="blue"
        title="Members Of"
        action={
          <Box display="flex" gap="16px">
            <Button variant="outlined" onClick={handleClickOpen}>
              ADD
            </Button>
          </Box>
        }
      />
      <CardContent {...(contentProps ?? {})}>{children}</CardContent>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add Members Of Room</DialogTitle>
        <DialogContent>
          <Autocomplete
            sx={{ width: 300 }}
            {...autocompleteProps}
            onInputChange={(event, value) => {}}
            getOptionLabel={(item) => item.name}
            onChange={(event: any, value) => {
              setRoomId(value.id);
            }}
            placeholder="Select a room"
            filterOptions={filterOptions}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label="Room"
                  margin="normal"
                  variant="outlined"
                  required
                />
              );
            }}
          />
          <TextField
            required
            select
            value={userRoleState}
            defaultValue={0}
            label="Role"
            margin="normal"
            fullWidth
            onChange={(e) => {
              setUserRoleState(e.target.value as unknown as number);
            }}
          >
            {Object.values(UserRole)[0].map((option: any) => (
              <MenuItem key={option.value} value={option.value}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};
